/** Google sign-in also asks for Gmail invite access, until someone on this browser says no to it. */
const DECLINED_KEY = 'gmail_invite_signin_declined';

/** Whether sign-in on this browser leaves the Gmail invite access out: someone unticked it before. */
export const inviteScopeDeclined = (): boolean => {
  try {
    return localStorage.getItem(DECLINED_KEY) === '1';
  } catch {
    return false;
  }
};

/** Sign-in's answer about Gmail invite access ("granted" or "declined"), so a "no" is not asked again here. */
export const rememberInviteScopes = (answer: string | null): void => {
  try {
    if (answer === 'declined') localStorage.setItem(DECLINED_KEY, '1');
    if (answer === 'granted') localStorage.removeItem(DECLINED_KEY);
  } catch {
    // Blocked storage: Google asks again at the next sign-in.
  }
};
